import { TypeUtils } from '@vectord/utils';

export default function isValidSbatGroupFilter(filter) {
  if (TypeUtils.isArray(filter)) {
    return filter.length > 0;
  }
  return TypeUtils.isPresent(filter);
}
